import type { FlightPlayerScoresFragment } from '../../../__generated__/hooks'
import PlayerScoreCard from '../components/PlayerScoreCard'

/**
 * Flat list of per-entry cards. Used for Golf, POLF, and Scramble — in
 * Scramble the API returns team rows but the card shape is identical
 * (single score row per hole, no contributor pill).
 */
const IndividualLayout = ({
  flight,
  currentHole,
  showChips,
  isNet,
  partialCard,
  isYourEntry,
  onSetScore,
  saving,
}: {
  flight: FlightPlayerScoresFragment[]
  currentHole: number
  showChips: boolean
  isNet: boolean
  partialCard?: boolean
  isYourEntry: (entryId: string) => boolean
  onSetScore: (scoreId: string, gross: number) => void
  saving: boolean
}) => (
  <div className="flex flex-col gap-3 px-2 mt-3">
    {flight.map((entry) => (
      <PlayerScoreCard
        key={entry.id}
        entry={entry}
        holeNumber={currentHole}
        isYou={isYourEntry(entry.id)}
        showChips={showChips}
        isNet={isNet}
        partialCard={partialCard}
        usedByTeam={false}
        onSetScore={onSetScore}
        saving={saving}
      />
    ))}
  </div>
)

export default IndividualLayout
